import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesFusion = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-fusion.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        You can <span className='text-pborange'>strengthen an item</span> by synthesizing it with Mana and materials. When you get a new weapon and find that you no longer need the weapon you had been using, use Fusion. The new weapon's HP and other stats will be <span className='text-pborange'>increased</span>, and you will be able to use this powered-up version in battle.
                    </p>{' '}<br/>
                    <p>
                        You can also convert items into Mana to obtain the item’s Title! 
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'fusion',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Synthesize your unused items to make the strongest weapons!'
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    ) 
}
